export default __webpack_public_path__ + "static/media/shutterstock_266821754-min.91631c04.jpg";